import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Calendar } from 'lucide-react';
export function SchedulePage() {
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-544">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-545">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-546">
          <Calendar className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-547" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-548">
            Class Schedule
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-549">
            Effective January 2025 — Find the perfect class time for you and
            your family
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-550">
        {/* Schedule Image */}
        <div className="mb-12" data-id="element-551">
          <Card className="p-4 md:p-8" data-id="element-552">
            <img src="https://images.squarespace-cdn.com/content/v1/5745c3fb45bf21fe3a81cd46/33636e75-badc-4e3f-80dd-03b10e5b1d36/January-25-Schedule.jpg" alt="Limitless Martial Arts Class Schedule - January 2025" className="w-full h-auto rounded-lg" data-id="element-553" />
          </Card>
        </div>

        {/* Important Notes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-554">
          <Card className="p-6" data-id="element-555">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-556">
              Lil' Warriors Classes
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-557">Ages 4-5</p>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-558">
              <li data-id="element-559">• Monday-Thursday: 4:30PM-5:00PM</li>
              <li data-id="element-560">• Monday-Thursday: 5:45PM-6:15PM</li>
            </ul>
          </Card>

          <Card className="p-6" data-id="element-561">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-562">
              Youth/Adult Classes
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-563">Ages 6 and up</p>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-564">
              <li data-id="element-565">• Monday-Thursday: 5:00PM-5:45PM</li>
              <li data-id="element-566">• Monday-Thursday: 6:15PM-7:00PM</li>
              <li data-id="element-567">• Saturday: 10:00AM-10:45AM</li>
            </ul>
          </Card>
        </div>

        {/* Special Classes */}
        <div className="mb-12" data-id="element-568">
          <Card className="p-6" data-id="element-569">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-570">
              Special Programs
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-571">
              <div data-id="element-572">
                <h4 className="font-semibold text-primary mb-2" data-id="element-573">
                  TEAM (Competition)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-574">Invite Only</p>
                <p className="text-sm text-gray-600" data-id="element-575">Monday: 7:00PM-8:30PM</p>
                <p className="text-sm text-gray-600" data-id="element-576">
                  Wednesday: 7:00PM-8:30PM
                </p>
                <p className="text-sm text-gray-600" data-id="element-577">Friday: 5:30PM-7:30PM</p>
              </div>
              <div data-id="element-578">
                <h4 className="font-semibold text-primary mb-2" data-id="element-579">
                  Running Group
                </h4>
                <p className="text-sm text-gray-600" data-id="element-580">Tuesday: 7:00PM</p>
                <p className="text-sm text-gray-600" data-id="element-581">Saturday: 8:00AM</p>
                <p className="text-sm text-gray-600 italic" data-id="element-582">
                  (Resumes in Spring)
                </p>
              </div>
              <div data-id="element-583">
                <h4 className="font-semibold text-primary mb-2" data-id="element-584">FORMS Class</h4>
                <p className="text-sm text-gray-600" data-id="element-585">Yellow Belt and up</p>
                <p className="text-sm text-gray-600" data-id="element-586">Thursday: 7:00PM-7:30PM</p>
              </div>
            </div>
          </Card>
        </div>

        {/* CTA */}
        <Card className="p-8 md:p-12 text-center bg-gradient-to-r from-primary to-primary-dark text-white" data-id="element-587">
          <h2 className="text-3xl font-bold mb-4" data-id="element-588">Ready to Get Started?</h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-589">
            Try any class for 4 weeks with our special introductory offer. No
            long-term commitment required.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-590">
            <Link to="/trial" data-id="element-591">
              <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-592">
                Start Your 4-Week Trial
              </Button>
            </Link>
            <Link to="/contact" data-id="element-593">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-594">
                Contact Us
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </main>;
}